








































import { defineComponent, PropType, ref, toRefs, computed } from '@vue/composition-api';
import {
  SplitTestFormData,
  AdgroupFormData,
  CampaignFormData,
  SplitTestType,
  SplitTestTargetResult,
  NormalCreativeList,
} from '@tt4b/ttam-enums';

import Variable from './variable/index.vue';
import KeyMetric from './key-metric/index.vue';
import DailyBudget from './daily-budget/index.vue';
import TestSchedule from './test-schedule/index.vue';
import BudgetPower from './power/index.vue';
import { MessageBox } from 'byted-vui';
import { i18n } from '@tt4b/ttam-i18n';

const name = 'ttam-split-test-setting-compose';

export default defineComponent({
  name,
  components: {
    Variable,
    KeyMetric,
    DailyBudget,
    TestSchedule,
    BudgetPower,
  },
  props: {
    splitTestFormData: {
      type: Object as PropType<SplitTestFormData>,
      default: () => ({}),
    },
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
    },
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
    },
    creativeBatchFormData: {
      type: Array as PropType<NormalCreativeList>,
      default: () => [],
    },
    isShowResetWarning: {
      type: Boolean,
      default: false,
    },
    getAccountNowTimestamp: {
      type: Function,
      default: () => () => 0,
    },
  },
  setup(props, { emit }) {
    const onChange = (val: Partial<SplitTestFormData>) => emit('change', val);

    const onAbTestTypeChange = async (abTestType: SplitTestType) => {
      try {
        if (abTestType !== props.splitTestFormData.abTestType && props.isShowResetWarning) {
          await MessageBox.confirm(
            i18n.t('module_split_test_variable_change_hint') as string,
            i18n.t('module_split_test_variable_change_header') as string,
            {
              confirmButtonText: i18n.t('common_confirm') as string,
              cancelButtonText: i18n.t('common_cancel') as string,
              type: 'warning',
            },
          );
        }
        onChange({ abTestType });
      } catch (e) {
        // nothing
      }
    };

    const onKeyMetricChange = (keyMetric: SplitTestTargetResult) => {
      onChange({ keyMetric });
    };

    const onBudgetChange = (budget: string) => {
      onChange({ budget });
    };

    const onStartTimeChange = (startTime: string) => {
      onChange({ startTime });
    };

    const onEndTimeChange = (endTime: string) => {
      onChange({ endTime });
    };

    return {
      name,
      onAbTestTypeChange,
      onKeyMetricChange,
      onBudgetChange,
      onEndTimeChange,
      onStartTimeChange,
    };
  },
});
